<template>
  <div :id="id" class="chapter-section panel">
    <p class="panel-heading">{{ $t(`chapter2.title`) }}</p>

    <fieldset class="box">
      <b-field
        :label="$t(`chapter2.q0.title`)"
        :type="store.getFieldError('datenbeschreibung', 'artDerDaten') ? 'is-danger' : ''"
        :message="store.getFieldError('datenbeschreibung', 'artDerDaten')"
      >
        <div v-for="type in artDerDatenOptions" :key="type">
          <b-checkbox
            :required="true"
            v-model="study.datenbeschreibung.artDerDaten"
            :native-value="type"
            @change="onArtDerDatenChange"
          >
            {{ $t(`chapter2.q0.${type}`) }}
          </b-checkbox>

          <b-field
            v-if="
              type === 'biometrischeDaten' &&
              study.datenbeschreibung.artDerDaten.includes('biometrischeDaten')
            "
            :type="
              store.getFieldError('datenbeschreibung', 'artDerBiometrischenDaten')
                ? 'is-danger'
                : ''
            "
            :message="store.getFieldError('datenbeschreibung', 'artDerBiometrischenDaten')"
          >
            <b-input
              :required="study.datenbeschreibung.artDerDaten.includes('biometrischeDaten')"
              v-model="study.datenbeschreibung.artDerBiometrischenDaten"
              :placeholder="$t(`chapter2.q0.biometrischeDatenPlaceholder`)"
              @blur="save"
            />
          </b-field>

          <b-field
            v-if="
              type === 'gesundheitsDaten' &&
              study.datenbeschreibung.artDerDaten.includes('gesundheitsDaten')
            "
            :type="
              store.getFieldError('datenbeschreibung', 'artDerGesundheitsDaten') ? 'is-danger' : ''
            "
            :message="store.getFieldError('datenbeschreibung', 'artDerGesundheitsDaten')"
          >
            <b-input
              :required="study.datenbeschreibung.artDerDaten.includes('gesundheitsDaten')"
              v-model="study.datenbeschreibung.artDerGesundheitsDaten"
              :placeholder="$t(`chapter2.q0.gesundheitsDatenPlaceholder`)"
              @blur="save"
            />
          </b-field>

          <b-field
            v-if="type === 'sonstige' && study.datenbeschreibung.artDerDaten.includes('sonstige')"
            :type="
              store.getFieldError('datenbeschreibung', 'artDerDatenSonstige') ? 'is-danger' : ''
            "
            :message="store.getFieldError('datenbeschreibung', 'artDerDatenSonstige')"
          >
            <b-input
              :required="study.datenbeschreibung.artDerDaten.includes('sonstige')"
              v-model="study.datenbeschreibung.artDerDatenSonstige"
              :placeholder="$t(`chapter2.q0.sonstigePlaceholder`)"
              @blur="save"
            />
          </b-field>

          <b-field
            :label="$t(`chapter2.q0a.title`)"
            v-if="type === 'gewebeproben' && showBioproben"
          >
            <div v-for="option in bioProbenOptions" :key="option">
              <b-checkbox
                v-model="study.datenbeschreibung.bioProbenNachErfuellung"
                :native-value="option"
                @change="onBioProbenNachErfuellungChange"
              >
                {{ $t(`chapter2.q0a.${option}`) }}
              </b-checkbox>
              <b-field
                v-if="
                  option === 'sonstiges' &&
                  study.datenbeschreibung.bioProbenNachErfuellung.includes('sonstiges')
                "
              >
                <b-input
                  v-model="study.datenbeschreibung.bioProbenNachErfuellungSonstiges"
                  :placeholder="$t(`chapter2.q0a.sonstigesPlaceholder`)"
                  @blur="save"
                />
              </b-field>
            </div>
          </b-field>
        </div>
      </b-field>
    </fieldset>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStudyStore } from '@/stores/studyStore'
import { BCheckbox, BField, BInput } from 'buefy'

defineProps<{ id: string; modelValue?: object }>()

const store = useStudyStore()
const study = store.study
const title = 'Datenbeschreibung'

const artDerDatenOptions = [
  'geburtsdatumAlter',
  'physischeMerkmale',
  'rasseUndEthnie',
  'genetischeDaten',
  'biometrischeDaten',
  'gesundheitsDaten',
  'datenZumSexualleben',
  'sonstige',
  'gewebeproben',
]

const bioProbenOptions = [
  'vernichtet',
  'anIbdfUebergeben',
  'studienvertrag',
  'internerVersand',
  'externerVersand',
  'sonstiges',
]

const save = () => {
  store.updateChapter('datenbeschreibung', study.datenbeschreibung)
}

const showBioproben = computed(() => study.datenbeschreibung.artDerDaten.includes('gewebeproben'))

function onArtDerDatenChange() {
  if (!(study.datenbeschreibung.artDerDaten || []).includes('biometrischeDaten')) {
    study.datenbeschreibung.artDerBiometrischenDaten = undefined
  }
  if (!(study.datenbeschreibung.artDerDaten || []).includes('gesundheitsDaten')) {
    study.datenbeschreibung.artDerGesundheitsDaten = undefined
  }
  if (!(study.datenbeschreibung.artDerDaten || []).includes('sonstige')) {
    study.datenbeschreibung.artDerDatenSonstige = undefined
  }
  if (!(study.datenbeschreibung.artDerDaten || []).includes('gewebeproben')) {
    study.datenbeschreibung.bioProbenNachErfuellung = []
    study.datenbeschreibung.bioProbenNachErfuellungSonstiges = undefined
  }
  save()
}

function onBioProbenNachErfuellungChange() {
  if (!(study.datenbeschreibung.bioProbenNachErfuellung || []).includes('sonstiges')) {
    study.datenbeschreibung.bioProbenNachErfuellungSonstiges = undefined
  }
  save()
}
</script>

<style scoped></style>
